import validatorIndex from "./validatorIndex"

const validateNonSpecific=(formData)=>
    {
     for (let pathway in formData.twrValid)
        {
        if (formData.twrValid[pathway])
            {
            return formData
            }
        }


    if (formData.weightLoss)
        {
        formData.message.nonSpecific= "For people with unexplained weight loss, which is a symptom of several cancers including colorectal, gastro‑oesophageal, lung, prostate, pancreatic and urological cancer, carry out an assessment for additional symptoms, signs or findings that may help to clarify which cancer is most likely and offer urgent investigation or a suspected cancer pathway referral (for an appointment within 2 weeks). Consider referral on the non-specific sypmptoms pathway if >5% weight loss in the last 3 months or strong clinical concern.  "
        formData.twrValid.nonSpecific=true
        }

    if (formData.appetiteLoss)
        {
        let message = "For people with unexplained weight loss, which is a symptom of several cancers including colorectal, gastro‑oesophageal, lung, prostate, pancreatic and urological cancer, carry out an assessment for additional symptoms, signs or findings that may help to clarify which cancer is most likely and offer urgent investigation or a suspected cancer pathway referral (for an appointment within 2 weeks). Consider referral on the non-specific symptoms pathway if the appetite lost has persisted for four weeks or more or strong clinical concern. "

        if (formData.message.nonSpecific==="")
            {
            formData.message.nonSpecific=message
            }
        else
            {
            formData.message.nonSpecific += message
            }

        formData.twrValid.nonSpecific=true
        }


    if (formData.dvt)
        {
            let message = "For people with deep vein thrombosis, which is associated with several cancers including urogenital, breast, colorectal and lung cancer carry out an assessment for additional symptoms, signs or findings that may help to clarify which cancer is most likely and consider urgent investigation or a suspected cancer pathway referral (for an appointment within 2 weeks)."
    
            if (formData.message.nonSpecific==="")
                {formData.message.nonSpecific=message}
            else
                {formData.message.nonSpecific += message}
        }
    
        

    if (formData.abdoPain || formData.bonePain || formData.nonSpecPain)
        {
        let message = "Consider referring people with vague abdominal pain bone pain or other non-specific, bone pain or other non-specific pain, on the non-specific symptoms pathway if the pain has persisted for over four weeks or there is strong concern"

            if (formData.message.nonSpecific==="")
                {formData.message.nonSpecific=message}
            else
                {formData.message.nonSpecific += message}

        formData.twrValid.nonSpecific=true
        }

    if (formData.fatigue || formData.malaise || formData.distension)
        {
            let message = "Consider referring people with new constitutional symptoms including fatigue, malaise or bloating on the non-specific symptoms pathway if the symptoms have persisted for over four weeks or there is strong concern"

            if (formData.message.nonSpecific==="")
                {formData.message.nonSpecific=message}
            else
                {formData.message.nonSpecific += message}

        formData.twrValid.nonSpecific=true
        }

   

    if (formData.sex==="male")
        {
        formData.investigations.push("PSA")
        }
    else
        {
        formData.investigations.push("Ca125")
        }
    }

    export default validateNonSpecific


    